import i18next from '../i18n';
import type { TOptions } from 'i18next';

/**
 * i18next's `TFunction` overloads are keyed to your JSON resources; passing a plain
 * `string` key does not match those overloads, so TypeScript rejects `options` as the
 * second argument. A narrow cast matches runtime behavior for this helper.
 */
const tForGenericKey = i18next.t as (key: string | string[], options?: TOptions) => string;

export function translate(key: string, options?: TOptions): string {
  return tForGenericKey(key, options);
}
